import React from 'react'
import '../News.css'
import { SearchRounded } from '@mui/icons-material'
import { Tweet } from 'react-tweet'

function News() {

async function search() {
    const url = 'https://api.twitter.com/2/users/by/username/Binit_Acharya7';
const resp = await fetch(url, {
  headers: { Authorization: `Bearer ${`AAAAAAAAAAAAAAAAAAAAAMm17AEAAAAAthAAP65jz0ou37e5NOqlOnOrZcs%3DD6vLZPHNpayRDSUpjTSr1ukFelctAnSiAeRoHh67pkJCzUOV8R`}` }
});
const json = await resp.json();
return json;
}
  return (
    <div className='news'>
        <div className="news__search">
            <SearchRounded className="news__searchIcon" fontSize='small' />
            <input type="text" className="news__searchBox" placeholder="Search" />
        </div>
        <div className="news__trendingContainer news__newsContainer">
            <h2>Today's News</h2>
            <Tweet id="1628832338187636740" />
        </div>
        <div className="news__trendingContainer">
            <h2>What's Happening</h2>
            <Tweet id="1628832338187636740" />
            {search().name}
        </div>
        <div className="news__whoToFollow news__trendingContainer">
            <h2>Who to Follow</h2>
            <Tweet id="1628832338187636740" />
        </div>
    </div>
  )
}

export default News